// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
// This file is replaced during build by using the `fileReplacements` array.
// `ng build -c staging-sms` replaces `environment.ts` with `sms/environment.staging.ts`.
// `ng build -c staging` replaces `environment.ts` with `environment.staging.ts`. *** Identic version
// The list of file replacements can be found in `angular.json`.
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --staging` replaces `environment.ts` with `environment.staging.ts`.
// The list of file replacements can be found in `angular.json`.

// import { LogLevel } from "angular-auth-oidc-client";

export const environment: any = {
  production: false,
  recaptcha: {
    siteKey: '6LdCJDIpAAAAANWlDQf2SbJE8sQQYrB3SfJcAFYk',
    secretKey: '6LdCJDIpAAAAACvjsFaLavky5Xe3EG6awI-8UkIj',
  },
  ADMIN_ROLE: 'Administrators',
  ANON_TEMPLATE_API_URL: 'https://test.school-management-system.app.uq.edu.au/API/Template/v1.0',  // For anon-templates
  API_BASE_URL: 'https://stagingapi.acarcinom.org.au/v1.0',
  APP_NAME: 'ACARCinom',
  // AUTH_LOG_LEVEL: LogLevel.Debug,
  IDSVR4_API_CLIENT: 'ACARCINOM.UI.Test',
  IDSVR4_API_SCOPE: 'ACARCINOM.API.Test',
  APP_LICENCE_ID: '0aca873c-c85b-4826-94b3-ef2e65208668',
  // ROUTE_DEBUG: true,
  SECURE_IMAGE_API_URL: 'https://test.school-management-system.app.uq.edu.au/API/MediaStore/v1.0/Secure',
  SITE_LOGO: 'logo-ACARCinom.jpg',
  SITE_SHORT_TITLE: 'ACARCinom',
  SITE_TITLE: 'Cancer Data Portal',
  SSO_SERVER_URL: 'https://identity.school-management-system.app.uq.edu.au/v2',
  // STORAGE: 'local',  // 'local' | 'session' | 'cookie';  // defaults to 'local'
  // UI_URL: 'https://servicesstaging.identic.com.au/staging/UI/Service',
  VIRTUAL_DIR: '/',
  Api: {
    IdenticProduct: 'Services',
    Licence: {
      Licence: 'licence'
    }
  }
};
